import { lazy, Suspense } from 'react';
import { useAppMRU } from '../../contexts/appMru.context';

const AppMRUDrawer = lazy(() => import('@chiroup/components/AppMRUDrawer'));

type Props = {
  enabled: boolean;
};

const AppMRUDrawerLoader = ({ enabled }: Props) => {
  const { isDrawerOpen } = useAppMRU();

  if (!enabled || !isDrawerOpen) return null;

  return (
    <Suspense fallback={null}>
      <AppMRUDrawer title="Recent CPT Codes" />
    </Suspense>
  );
};

export default AppMRUDrawerLoader;
